import React from "react"

export const XmarkIcon = ({
  className,
  size = 1,
  color = "#F0C202",
  strokeWidth = "4",
}) => {
  return (
    <svg
      className={className}
      width={30 * size}
      height={30 * size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M28 2 2 28M2 2l26 26" stroke={color} strokeWidth={strokeWidth} />
    </svg>
  )
}
